import {TablePaginationConfig} from 'antd/es/table';
import React from 'react';

import {ReactComponent as ArrowRightIcon} from 'shared/assets/arrow-right.svg';

type TGetTablePaginationDefaultConfigArgs = Pick<
    TablePaginationConfig,
    'defaultPageSize' | 'pageSizeOptions' | 'locale' | 'showSizeChanger' | 'showQuickJumper' | 'position'
>

export const getTablePaginationDefaultConfig = ({
    defaultPageSize = 10,
    pageSizeOptions = ['10', '20', '50', '100'],
    locale = {items_per_page: 'на странице', jump_to: ''},
    showSizeChanger = true,
    showQuickJumper = {
        goButton: <ArrowRightIcon className="pagination_jumper" />,
    },
}: TGetTablePaginationDefaultConfigArgs = {}): TablePaginationConfig => ({
    defaultPageSize,
    pageSizeOptions,
    showSizeChanger,
    locale,
    showQuickJumper,
    position: ['bottomLeft'],
});
